import { Injectable, inject } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import { HamtaKvalitetssakradGrotvolymResponseDTO } from "~app/common/models/planera/v2/HamtaKvalitetssakradGrotvolymResponseDTO";
import { IAtgard } from "~app/features/planera/model/IAtgard";
import { ApiClientService } from "../../../common/services/api-client.service";
import { ListEvents } from "../events/list-events";
import { PlaneraKartaEventService } from "../planera-karta/planera-karta-event.service";

@Injectable({
    providedIn: "root"
})
export class ArbetsorderAtgardService {
    grotvolymer$ = new Subject<HamtaKvalitetssakradGrotvolymResponseDTO>();

    private readonly apiClient = inject(ApiClientService);
    private readonly planeraKartaEventService = inject(PlaneraKartaEventService);

    avslutaArbetsorder(arbetsorderId: number): Observable<void> {
        return this.apiClient.post(`arbetsorder/${arbetsorderId}/AvslutaArbetsorder`, { id: arbetsorderId }, false);
    }

    fetchGrotvolymFromStina(arbetsorderId: number): Observable<HamtaKvalitetssakradGrotvolymResponseDTO> {
        const obs: Observable<HamtaKvalitetssakradGrotvolymResponseDTO> = this.apiClient.get(`arbetsorder/${arbetsorderId}/HamtaKvalitetssakradGrotvolym`, false);

        return obs
            .pipe(tap((x) => {
                this.grotvolymer$.next(x);
            }));
    }

    hoverToggle(atgard: IAtgard, hovering: boolean): void {
        atgard.isHovering = hovering;
        this.planeraKartaEventService.emit(ListEvents.mouseOverAtgard, { guid: atgard.guid,
            isMouseover: hovering });
    }
}
